import { render, staticRenderFns } from "./CustomerLog.vue?vue&type=template&id=5716b1ef&scoped=true&"
import script from "./CustomerLog.vue?vue&type=script&lang=js&"
export * from "./CustomerLog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerLog.vue?vue&type=style&index=1&id=5716b1ef&lang=scss&scoped=true&"
import style2 from "./CustomerLog.vue?vue&type=style&index=2&id=5716b1ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716b1ef",
  null
  
)

export default component.exports